module.exports = "data:image/svg+xml;base64,PHN2Zz4KICA8ZGVmcz4KICAgIDwhLS0gVE9ETyB2aWV3Qm94IHByb2JhYmx5IHdyb25nIC0tPgogICAgPHN5bWJvbCBpZD0iYnJhY2UiIG92ZXJmbG93PSJ2aXNpYmxlIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+Cgk8ZGVzYz5icmFjZTwvZGVzYz4KCTxwYXRoIHN0cm9rZT0iY3VycmVudENvbG9yIgoJCWQ9Im0xLjUsNDkuNDk5OTk2YzAsLTE2LjE2NjY2OCA4LjE2NjY2NiwtMjQuMjQ5OTk2IDI0LjQ5OTk5OCwtMjQuMjQ5OTk2czI0LjQ5OTk5OCwtOC4wODMzMzYgMjQuNDk5OTk4LC0yNC4yNTAwMDJjMCwxNi4xNjY2NjYgOC4xNjY2NjQsMjQuMjUwMDAyIDI0LjQ5OTk5NiwyNC4yNTAwMDJzMjQuNSw4LjA4MzMyOCAyNC41LDI0LjI0OTk5NiIvPgogICAgPC9zeW1ib2w+CiAgPC9kZWZzPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/icons/brace.svg
// module id = 697
// module chunks = 0